import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from "./item.reducer";

export const selectFeature = createFeatureSelector<State>('Item');

export const ItemSelector = {
	selectRequestProcessing: createSelector(
		selectFeature,
		(state) => state.requestProcessing
	),

	selectTypesListRequestProcessing: createSelector(
		selectFeature,
		(state) => state.typesList.requestProcessing
	),
	selectTypesListData: createSelector(
		selectFeature,
		(state) => state.typesList.data
	),

	selectItemListResponse: createSelector(
		selectFeature,
		(state) => state.itemList.response
	),
	selectItemListRequestProcessing: createSelector(
		selectFeature,
		(state) => state.itemList.requestProcessing
	),
	selectItemListCriteria: createSelector(
		selectFeature,
		(state) => state.itemList.criteria
	),

	selectGetItem: createSelector(
		selectFeature,
		(state) => state.item.response
	),

	selectGetItemsCriteria: createSelector(
		selectFeature,
		(state) => state.GetItems.criteria
	),
	selectGetItemsResponse: createSelector(
		selectFeature,
		(state) => state.GetItems.response
	),
	selectGetItemsRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetItems.requestProcessing
	),

	selectPostCommentResponse: createSelector(
		selectFeature,
		(state) => state.PostComment.response
	),

	selectLikeItemResponse: createSelector(
		selectFeature,
		(state) => state.LikeItem.response
	),

	selectCompareItemResponse: createSelector(
		selectFeature,
		(state) => state.CompareItems.response
	),

	selectAddToCartItemResponse: createSelector(
		selectFeature,
		(state) => state.AddToCart.response
	),

	selectGetItemFromCartResponse: createSelector(
		selectFeature,
		(state) => state.GetItemFromCart.response
	),

	selectDeleteItemFromCartResponse: createSelector(
		selectFeature,
		(state) => state.DeleteItemFromCart.response
	),

	selectRemoveItemFromCartResponse: createSelector(
		selectFeature,
		(state) => state.RemoveItemFromCart.response
	),

	selectCheckoutDataResponse: createSelector(
		selectFeature,
		(state) => state.CheckoutData.response
	),

	selectPhItemPaymentStatusResponse: createSelector(
		selectFeature,
		(state) => state.phItemPaymentStatus.response
	),
	selectGetAllCustomJewelleryResponse: createSelector(
		selectFeature,
		(state) => state.GetAllCustomJewellery.response
	),
	selectGetAllCustomJewelleryRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetAllCustomJewellery.requestProcessing
	),
	selectGetAllCustomJewelleryCriteria: createSelector(
		selectFeature,
		(state) => state.GetAllCustomJewellery.criteria
	),

	selectCustomJewelleryCheckOutDetailResponse: createSelector(
		selectFeature,
		(state) => state.CustomJewelleryCheckOutDetail.response
	),

	selectCustomJewelleryPaymentStatusResponse: createSelector(
		selectFeature,
		(state) => state.CustomJewelleryPaymentStatus.response
	),

	selectCheckCustomJewPaymentTypeResponse: createSelector(
		selectFeature,
		(state) => state.CheckCustomJewPaymentType.response

	),

	selectGetReview: createSelector(
		selectFeature,
		(state) => state.GetReview.response
	),

	selectGetReviewsCriteria: createSelector(
		selectFeature,
		(state) => state.GetReview.criteria
	),
	selectGetReviewsResponse: createSelector(
		selectFeature,
		(state) => state.GetReview.response
	),

	selectGetAllItemsForWeb: createSelector(
		selectFeature,
		(state) => state.GetAllItemsForWeb.response
	),

	selectGetAllItemsForWebsCriteria: createSelector(
		selectFeature,
		(state) => state.GetAllItemsForWeb.criteria
	),
	selectGetAllItemsForWebsResponse: createSelector(
		selectFeature,
		(state) => state.GetAllItemsForWeb.response
	),
	selectGetAllItemsForWebsRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetAllItemsForWeb.requestProcessing
	),

	selectGetAllCompareData: createSelector(
		selectFeature,
		(state) => state.GetAllCompareData.response
	),

	selectGetAllCompareDataCriteria: createSelector(
		selectFeature,
		(state) => state.GetAllCompareData.criteria
	),
	selectGetAllCompareDataResponse: createSelector(
		selectFeature,
		(state) => state.GetAllCompareData.response
	),
	selectGetAllCompareDatasequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetAllCompareData.requestProcessing
	),

	selectGetStoreItemsForWebResponse: createSelector(
		selectFeature,
		(state) => state.GetStoreItemsForWeb.response
	),
	selectGetStoreItemsForWebRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetStoreItemsForWeb.requestProcessing
	),
	selectGetStoreItemsForWebCriteria: createSelector(
		selectFeature,
		(state) => state.GetStoreItemsForWeb.criteria
	),

	selectGetCustomJewelleryPriceDetailsResponse: createSelector(
		selectFeature,
		(state) => state.GetCustomJewelleryPriceDetails.response
	),

	selectGetCustomJewelleryPriceDetailsRequestProcessing: createSelector(
		selectFeature,
		(state) => state.GetCustomJewelleryPriceDetails.requestProcessing
	),

	selectCheckServiceAbilityResponse: createSelector(
		selectFeature,
		(state) => state.CheckServiceAbility.response
	),

	selectCountTotalItemResponse: createSelector(
		selectFeature,
		(state) => state.CountTotalItem.response
	),
};
